import { toArray } from 'lodash-es';
import type { FieldPath } from 'react-hook-form';
import type { SystemPackageAppVersion } from '../../pages/create-system-package-version-page/createSystemPackageVersionPage.model';

export function transformHiddenFieldsListIntoMap(
  hiddenFieldsList?: FieldPath<SystemPackageAppVersion>[],
): Record<FieldPath<SystemPackageAppVersion>, boolean> {
  return toArray(hiddenFieldsList)?.reduce(
    (accum, current) => ({
      ...accum,
      [current]: true,
    }),
    {} as Record<FieldPath<SystemPackageAppVersion>, boolean>,
  );
}
